var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('myheader',{attrs:{"backFlag":true,"backIntercept":true,"headTitle":"文件签署"},on:{"childBackEvent":_vm.back}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }